<template>

</template>

<script>
import CONST from "@/utils/Constants";
import GAMixins from "../mixins/GAMixins";

export default {
  name: "CheckoutComponent",
  data() {
    return {
      data: null,
      productList: [],
    }
  },
  props: [
    'flagSolbiati',
    'flagFabrics',
  ],
  mixins: [
    GAMixins
  ],
  methods: {
    printSteps(data, value, cart) {
      ACC.log.group("printSteps", value)
      ACC.log.info({'data': data})

      const entry = {
        event: value,
        ecommerce: {
          currency: ACC.config.user.currency.isocode,
          commercial_organization: this.getCommercialOrganization(),
          items: this.getProductEntries(data),
        }
      }

      if (value === 'add_shipping_info') {
        entry.ecommerce.value = cart.commOrgConditionMap[cart.commercialOrganizationData.code].total.value;
        entry.ecommerce.shipping_tier = cart.shipper.codShipper
      } else if (value === 'add_payment_info') {
        entry.ecommerce.value = cart.commOrgConditionMap[cart.commercialOrganizationData.code].total.value;
        entry.ecommerce.payment_mode = cart.paymentTypeId
        entry.ecommerce.payment_type = cart.payCondition.paymentID
      }

      this.pushEvent(entry);
      console.groupEnd();
    },

  },
  created() {
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.CHECKOUT.STEP1, data => {
      this.data = data;
      this.getEntriesFromCheckout(data.data.cart, 'begin_checkout');
    });
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.CHECKOUT.STEP2, data => {
      this.data = data;
      this.getEntriesFromCheckout(data.data.cart, 'confirm_delivery_address');
    });
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.CHECKOUT.STEP3, data => {
      this.data = data;
      this.getEntriesFromCheckout(data.data.cart, 'add_shipping_info');
    });
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.CHECKOUT.STEP4, data => {
      this.data = data;
      this.getEntriesFromCheckout(data.data.cart, 'add_payment_info');
    });
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.CHECKOUT.STEP5, ({data}) => {
      this.data.cart = data;
      this.getEntriesFromCheckout(data, 'order_confirmation');
    });
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.CHECKOUT.ONLY_ONE_STEP, cart => {
      this.getEntriesFromCheckout(cart, 1);
    });

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/global/lptGoogleAnalytics/components/CheckoutComponent.vue